import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2, AlertCircle, Clock, XCircle } from 'lucide-react';
import { StripeStatusBadge } from '../../model/stripe/stripe-connect-model';

interface StripeConnectStatusProps {
  status: StripeStatusBadge;
  className?: string;
  showIcon?: boolean;
}

const StripeConnectStatus: React.FC<StripeConnectStatusProps> = ({
  status,
  className = '',
  showIcon = true
}) => {
  const { t } = useTranslation();

  const getStatusConfig = () => {
    switch (status) {
      case 'not_configured':
        return {
          label: t('stripe.status.notConfigured'),
          bgColor: 'bg-gray-100 dark:bg-gray-700',
          textColor: 'text-gray-800 dark:text-gray-300',
          icon: XCircle
        };
      case 'pending':
        return {
          label: t('stripe.status.pending'),
          bgColor: 'bg-yellow-100 dark:bg-yellow-900/30',
          textColor: 'text-yellow-800 dark:text-yellow-400',
          icon: Clock
        };
      case 'verified':
        return {
          label: t('stripe.status.verified'),
          bgColor: 'bg-green-100 dark:bg-green-900/30',
          textColor: 'text-green-800 dark:text-green-400',
          icon: CheckCircle2
        };
      case 'restricted':
        return {
          label: t('stripe.status.restricted'),
          bgColor: 'bg-red-100 dark:bg-red-900/30',
          textColor: 'text-red-800 dark:text-red-400',
          icon: AlertCircle
        };
      default:
        return {
          label: status,
          bgColor: 'bg-gray-100 dark:bg-gray-700',
          textColor: 'text-gray-800 dark:text-gray-300',
          icon: XCircle
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor} ${className}`}
    >
      {showIcon && <Icon className="w-3.5 h-3.5 mr-1.5" />}
      {config.label}
    </span>
  );
};

export default StripeConnectStatus;
